module.exports = __webpack_public_path__ + "img/p1-info@2x.6803cce3.jpg";